import { useRef } from 'react';

import ConfirmModalContext from './ConfirmModalContext';
import ConfirmModal from './ConfirmModal';

const ConfirmModalProvider = props => {
  const {
    children
  } = props;

  const showConfirmModalRef = useRef();

  const showConfirmModal = message => {
    return showConfirmModalRef.current(message);
  }

  return (
    <ConfirmModalContext.Provider value={{ showConfirmModal }}>
      {children}
      <ConfirmModal {...{ showConfirmModalRef }} />
    </ConfirmModalContext.Provider>
  )
}

export default ConfirmModalProvider;
